import api from "./api";
import { jwtDecode } from "jwt-decode";
import { showNotificationTopEnd } from "../util/utils";

const normalizeToken = (rawToken) => {
  if (!rawToken || typeof rawToken !== "string") return "";
  return rawToken.replace(/^Bearer\s+/i, "").trim();
};

export const callLogin = async (data) => {
  try {
    const response = await api.post("/login", data);

    const token = response.headers["authorization"];
    setToken(token);
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      showNotificationTopEnd("error", "Credenciales invalidas");
    }
    return error?.response || { status: 500 };
  }
};

export const callLogout = () => {
  clearStorage();
};

export const setToken = (token) => {
  const normalizedToken = normalizeToken(token);
  if (!normalizedToken) {
    localStorage.removeItem("token");
    return;
  }
  localStorage.setItem("token", normalizedToken);
};

export const clearStorage = () => {
  localStorage.removeItem("token");
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const isTokenValid = (tokenParam) => {
  const token = normalizeToken(tokenParam || getToken());
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token);
    const now = Date.now() / 1000;
    return exp > now;
  } catch {
    return false;
  }
};
